import React, { useEffect, createElement, Component } from 'react';
import posthog from 'posthog-js';
import confetti from 'canvas-confetti';
import { BrandHeader } from '../components/BrandHeader';
import { EyebrowLabel } from '../components/EyebrowLabel';
import { OrangeAccent } from '../components/OrangeAccent';
import { PageTransition } from '../components/PageTransition';
import { useAnswers } from '../context/AnswersContext';
export function Qualified() {
  const {
    answers
  } = useAnswers();
  // Inject GHL form_embed.js once
  useEffect(() => {
    if (document.querySelector('script[data-ghl-form-embed]')) return;
    const s = document.createElement('script');
    s.src = 'https://link.med-masters.com/js/form_embed.js';
    s.async = true;
    s.setAttribute('data-ghl-form-embed', 'true');
    document.body.appendChild(s);
  }, []);
  // Analytics: fire qualified_reached on mount; listen for GHL appointment_booked postMessage
  useEffect(() => {
    posthog.capture('qualified_reached', {
      ...answers
    });
    // Meta Pixel — qualified prospect reaching the booking page
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'Lead');
    }
    function handleMessage(e: MessageEvent) {
      if (typeof e.data === 'string' && e.data.includes('appointment')) {
        posthog.capture('appointment_booked', {
          ...answers
        });
      }
    }
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Confetti celebration on mount — fires from top corners, streams down for ~3s
  useEffect(() => {
    const duration = 3000;
    const end = Date.now() + duration;
    const colors = ['#FA4616', '#FFB800', '#2E7BFF', '#FFFFFF'];
    (function frame() {
      confetti({
        particleCount: 4,
        angle: 60,
        spread: 70,
        origin: {
          x: 0,
          y: 0
        },
        colors,
        startVelocity: 45,
        gravity: 0.9
      });
      confetti({
        particleCount: 4,
        angle: 120,
        spread: 70,
        origin: {
          x: 1,
          y: 0
        },
        colors,
        startVelocity: 45,
        gravity: 0.9
      });
      if (Date.now() < end) requestAnimationFrame(frame);
    })();
  }, []);
  const calendarSrc = `https://link.med-masters.com/widget/booking/kBhidH5FhnoWkNTzmUjt?` + `pps_q1_capacity=${encodeURIComponent(answers.capacity || '')}` + `&pps_q2_revenue=${encodeURIComponent(answers.revenue || '')}` + `&pps_q3_database=${encodeURIComponent(answers.database || '')}` + `&pps_q4_providers=${encodeURIComponent(answers.providers || '')}` + `&pps_q5_adspend=${encodeURIComponent(answers.adspend || '')}` + `&pps_q6_leadsource=${encodeURIComponent(answers.leadsource || '')}` + `&pps_q7_comfort=${encodeURIComponent(answers.comfort || '')}` + `&pps_q8_filming=${encodeURIComponent(answers.filming || '')}`;
  return <PageTransition data-id="element-152">
      <BrandHeader data-id="element-153" />
      <main className="flex-1 w-full max-w-[720px] mx-auto px-4 pb-20 pt-8 flex flex-col items-center text-center" data-id="element-154">
        <EyebrowLabel className="!text-orange mb-4" data-id="element-155">YOU'RE IN</EyebrowLabel>

        <h1 className="font-display font-extrabold text-[clamp(28px,4vw,40px)] tracking-tight text-ink leading-tight mb-6" data-id="element-156">
          Congratulations, You're Qualified!
        </h1>

        <OrangeAccent className="mb-6" data-id="element-157" />

        <p className="font-sans font-medium text-[17px] text-ink-soft mb-10" data-id="element-158">
          Book your <i data-id="element-159">Patient Profit System™</i> Install Call below. The
          calendar may take a few seconds to load.
        </p>

        <div className="w-full bg-white border border-line rounded-[16px] overflow-hidden" data-id="element-160">
          <iframe src={calendarSrc} style={{
          width: '100%',
          border: 'none',
          overflow: 'hidden',
          borderRadius: '16px',
          background: 'white',
          minHeight: '720px'
        }} scrolling="no" id="ghl-booking" title="Patient Profit System Install Call" data-id="element-161" />
        </div>
      </main>
    </PageTransition>;
}